module.exports = __webpack_public_path__ + "static/doublo-ML-e9f68c44ef666a58bd99960c90d973d8.gif";